export enum Role {
  TENANT_ADMIN = "TENANT_ADMIN",
  HOTEL_ADMIN = "HOTEL_ADMIN",
  FRONT_DESK = "FRONT_DESK",
  STAFF = "STAFF",
}

export type UserRoleFilter = Role | "SUPER_ADMIN" | "GUESTERIA_ADMIN";

export type TenantUserSortField =
  | "status"
  | "name"
  | "email"
  | "phone"
  | "role"
  | "group";

export type CustomRoleBase = Role;

// Base interface for common user fields to eliminate duplication
export interface BaseUserFields {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  address?: string;
  language?: string;
  preferredLanguage?: string;
  preferences?: Record<string, any>;
}

export interface CreateHotelAdminUserDto extends BaseUserFields {
  tenantId: string;
  username: string;
  password: string;
  hotelId: string;
  region?: string;
}

export interface CreateFrontDeskUserDto extends BaseUserFields {
  tenantId: string;
  username: string;
  password: string;
  hotelId: string;
  region?: string;
}

export interface CreateStaffUserDto extends BaseUserFields {
  hotelId: string;
  photoId?: string;
  teams?: string[];
  username: string;
  position?: string;
}

export interface CreateFrontDeskCustomRoleUserDto extends BaseUserFields {
  hotelId: string;
  photoId?: string;
  username: string;
  password: string;
  customRoleId: string;
}

export interface UpdateUserDto extends BaseUserFields {
  username?: string;
  photoId?: string;
  role?: Role;
  isActive?: boolean;
  teams?: string[];
  position?: string;
}

export interface UserFilters {
  roles?: UserRoleFilter[];
  positions?: string[];
  customRoleIds?: string[];
  accessGroupIds?: string[];
  tenantId?: string;
  tenantName?: string;
  tenantSlug?: string;
  search?: string;
  hotelId?: string;
  statusActivity?: string;
  createdFrom?: string;
  createdTo?: string;
  sortBy?: string | null;
  sortField?: string | null;
  sortDirection?: "asc" | "desc" | null;
  limit?: number;
  offset?: number;
  currentPage?: number;
  perPage?: number;
}

export interface UserFilterRoleOption {
  id: string;
  name: string;
  type: "system" | "custom";
}

export interface UserFilterGroupOption {
  id: string;
  name: string;
}

export interface UserFilterOptions {
  positions: string[];
  roles: UserFilterRoleOption[];
  groups: UserFilterGroupOption[];
}

export interface TenantCustomRole {
  id: string;
  tenantId: string;
  name: string;
  description?: string | null;
  baseRole: CustomRoleBase;
  permissionKeys: string[];
  assigneeCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CustomRoleListQuery {
  search?: string;
}

export interface CreateTenantCustomRoleDto {
  name: string;
  description?: string;
  baseRole: CustomRoleBase;
  permissionKeys: string[];
}

export interface UpdateTenantCustomRoleDto {
  name?: string;
  description?: string | null;
  permissionKeys?: string[];
}

export interface CreateTenantUserDto extends BaseUserFields {
  username: string;
  email?: string;
  password?: string;
  pin?: string;
  hotelId?: string;
  photoId?: string;
  role?: Exclude<Role, Role.TENANT_ADMIN>;
  customRoleId?: string;
  position?: string;
}

export interface UserCreationResponse {
  id: string;
  keycloakUserId: string;
  role: Role;
  emailHash?: string;
  assignedCustomRoleId?: string;
}

export interface UserCustomRoleAssignmentDto {
  customRoleId: string;
  customRoleName: string;
  assignedAt: string;
  assignedByUserId: string | null;
}

export interface AssignmentResultDto {
  userId: string;
  assignedCustomRoleIds: string[];
  effectivePermissions: string[];
}
